<div class="az-content pd-y-20 pd-lg-y-30 pd-xl-y-40">
    <div class="container">
        <app-sidebar-accounts></app-sidebar-accounts>
        <!-- az-content-left -->
      
      <div class="az-content-body pd-lg-l-40 d-flex flex-column">
        <div class="az-content-breadcrumb">
          <span>Accounts</span>
          <span>Card</span>
          <span>Cars</span>
        </div>
        <h2 class="az-content-title">Account Card Vehicles</h2>

        <div class="row">
          <div class="col-md-8">
            <div class="az-content-label mg-b-5">All Vehicles List</div>
            <p class="mg-b-20">List of all registered Vehicles for this Card.</p>
          </div>
          <div class="col-md-4 mt-md-0 mt-3" align="right">
            <button class="btn btn-outline-success btn-rounded btn-sm" data-toggle="modal" data-target="#add">
              NEW &nbsp;<i class="fa fa-plus-circle"></i>
            </button>
          </div>
        </div>

        <div class="table-responsive mt-4">
          <table class="table table-hover mg-b-0">
            <thead>
              <tr>
                <th>ID</th>
                <th>Model</th>
                <th>Make</th>
                <th>Registration Number</th>
                <th>Fuel Type</th>
                <th>Action</th>
              </tr>
            </thead>
            <tbody>
              <tr *ngFor="let r of cars;">
                <th>{{r.id}}</th>
                <td>{{r.model}}</td>
                <td>{{r.make}}</td>
                <td>{{r.registrationNumber}}</td>
                <td>{{r.fuelType}}</td>
                <td>
                  <span class="text-primary pointer" title="Update Record" (click)="loadCar(r.id)">
                    <i class="fa fa-edit"></i>
                  </span>
                  <span class="text-danger pointer ml-2" title="Delete Record">
                    <i class="fa fa-trash-alt"></i>
                  </span>
                </td>
              </tr>
            </tbody>
          </table>
        </div><!-- table-responsive -->

        <div class="ht-40"></div>

        
      </div><!-- az-content-body -->
    
    </div><!-- container -->
</div><!-- az-content -->

<!-- Modals -->
<div class="modal fade" id="add" tabindex="-1" role="dialog" aria-hidden="true">
  <div class="modal-dialog modal-dialog-centered" role="document">
    <div class="modal-content">
      <div class="modal-header">
        <h5 class="modal-title text-center w-100" id="">CREATE VEHICLE</h5>
        <button type="button" class="close" data-dismiss="modal" aria-label="Close">
          <span aria-hidden="true">&times;</span>
        </button>
      </div>
      <div class="modal-body">
        <section>
          <form [formGroup]="addForm" (ngSubmit)="addCar(addForm)">
            <div class="container">
              <div class="row">
                <div class="col-md-12">
                  <div class="form-group">
                    Registration Number
                    <input type="text" formControlName="registrationNumber" placeholder="Registration Number" required class="form-control">
                  </div>
                </div>
                <div class="col-md-12">
                    <div class="form-group">
                      Model
                      <input type="text" formControlName="model" placeholder="Model" required class="form-control">
                    </div>
                </div>
                <div class="col-md-12">
                    <div class="form-group">
                      Make
                      <input type="text" formControlName="make" placeholder="Make" required class="form-control">
                    </div>
                  </div>
                  <div class="col-md-12">
                      <div class="form-group">
                        Fuel Type
                        <select formControlName="fuelType" class="form-control" required>
                            <option value="" selected disabled>choose...</option>
                            <option value="Diesel">Diesel</option>
                            <option value="Petrol">Petrol</option>
                        </select>
                      </div>
                  </div>
              </div>
            </div>
            <br><br>
            <div align="center">
              <button class="btn btn-sm btn-rounded btn-outline-danger" data-dismiss="modal" type="button"><i class="fa fa-times"></i>&nbsp; Cancel</button>
              <button class="ml-2 btn btn-rounded btn-sm btn-outline-primary" type="submit"><i class="fa fa-save"></i>&nbsp; Add Vehicle</button>
            </div>
          </form>
        </section>
      </div>      
    </div>
  </div>
</div>

<div class="modal fade" id="edit" tabindex="-1" role="dialog" aria-hidden="true">
  <div class="modal-dialog modal-dialog-centered" role="document">
    <div class="modal-content">
      <div class="modal-header">
        <h5 class="modal-title text-center w-100" id="">UPDATE VEHICLE</h5>
        <button type="button" class="close" data-dismiss="modal" aria-label="Close">
          <span aria-hidden="true">&times;</span>
        </button>
      </div>
      <div class="modal-body">
        <section>
          <form [formGroup]="editForm" (ngSubmit)="updateCar(editForm)">
            <div class="container">
                <div class="row">
                  <div class="col-md-12">
                    <div class="form-group">
                      Registration Number
                      <input type="text" formControlName="registrationNumber" placeholder="Registration Number" required class="form-control">
                    </div>
                  </div>
                  <div class="col-md-12">
                      <div class="form-group">
                        Model
                        <input type="text" formControlName="model" placeholder="Model" required class="form-control">
                      </div>
                  </div>
                  <div class="col-md-12">
                      <div class="form-group">
                        Make
                        <input type="text" formControlName="make" placeholder="Make" required class="form-control">
                      </div>
                    </div>
                    <div class="col-md-12">
                        <div class="form-group">
                          Fuel Type
                          <select formControlName="fuelType" class="form-control" required>
                              <option value="" selected disabled>choose...</option>
                              <option value="Diesel">Diesel</option>
                              <option value="Petrol">Petrol</option>
                          </select>
                        </div>
                    </div>
                </div>
              </div>
            <br><br>
            <div align="center">
              <button class="btn btn-sm btn-rounded btn-outline-danger" data-dismiss="modal" type="button"><i class="fa fa-times"></i>&nbsp; Cancel</button>
              <button class="ml-2 btn btn-rounded btn-sm btn-outline-primary" type="submit"><i class="fa fa-save"></i>&nbsp; Update Vehicle</button>
            </div>
          </form>
        </section>
      </div>      
    </div>
  </div>
</div>

<div class="modal fade" id="delete" tabindex="-1" role="dialog" aria-hidden="true">
  <div class="modal-dialog modal-dialog-centered" role="document">
    <div class="modal-content">
      <div class="modal-header">
        <h5 class="modal-title text-center w-100" id="">DELETE VEHICLE</h5>
        <button type="button" class="close" data-dismiss="modal" aria-label="Close">
          <span aria-hidden="true">&times;</span>
        </button>
      </div>
      <div class="modal-body">
        <section>
          <div>
            <div class="container">
              <div class="row">
                <div class="col-md-12">
                  <h2>You are about to delete a Vehicle!</h2>
                </div>
              </div>
            </div>
            <br><br>
            <div align="center">
              <button class="btn btn-sm btn-rounded btn-outline-primary" data-dismiss="modal" type="button"><i class="fa fa-times"></i>&nbsp; Cancel</button>
              <button class="ml-2 btn btn-rounded btn-sm btn-outline-danger" type="button"><i class="fa fa-trash-alt"></i>&nbsp; Delete Vehicle</button>
            </div>
          </div>
        </section>
      </div>      
    </div>
  </div>
</div>